import * as React from 'react'
import { MuiTextFieldFormik } from '@sales-center/components'
import { Field } from 'formik'
import {
  emailThresholdEntries,
  EmailThresholdEntry,
} from '@user/features/Activity/constants'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import MenuItem from '@mui/material/MenuItem'
import Tooltip from '@mui/material/Tooltip'

export function ReminderSelector({ disabled }: { disabled: boolean }) {
  return (
    <Stack>
      <Typography variant="body1" mt={1} fontSize={16}>
        Send Email Reminder
      </Typography>
      <Tooltip
        title={
          disabled
            ? 'Select a Due Date/Time in the future to enable reminders for this activity.'
            : ''
        }
        placement="top"
        arrow
        disableHoverListener={!disabled}
      >
        <div>
          <Field
            component={MuiTextFieldFormik}
            disabled={disabled}
            fullWidth
            name="reminderThreshold"
            select
            size="small"
            label=""
            default="None"
            inputProps={{ 'data-test-id': 'emailReminder' }}
          >
            {emailThresholdEntries.map((entry: EmailThresholdEntry) => (
              <MenuItem value={entry.value} key={entry.value}>
                {entry.name}
              </MenuItem>
            ))}
          </Field>
        </div>
      </Tooltip>
    </Stack>
  )
}
